// extracted by mini-css-extract-plugin
export var container = "_au-0";
export var containerTopRight = "_au-1";